import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';
import { START_BY_VALUES } from '../BaseForm';
import { Button, HeadingFive, Card, Theme } from 'hui/src/styled';
import { fillContainer, buttonAlignment, disabledButton } from './shared/SharedStyles';
import { trackEvent } from '../../../utils/googleAnalytics';
import { EventCategories, EventActions } from '../../../constants/Analytics';
import RadioButton from '../CustomQuestions/RadioButton';

const validate = values => {
  const errors = {};
  if (!values.start_by) {
    errors.start_by = `We couldn't find a start by date`;
  }
  return errors;
};

const SubHeading = styled.div`
  font-size: 1em;
  padding-bottom: 2em;
  color: ${Theme.greyMedium};
`;

const StartByStep = ({ onSubmit, invalid, category }) => (
  <Form onSubmit={onSubmit} style={fillContainer}>
    <Card center m={0} p={1} style={fillContainer}>
      <HeadingFive mb={0.5}>When do you want the work to start?</HeadingFive>
      <SubHeading>Tap an option below to continue</SubHeading>
      <RadioButton
        stacked
        options={START_BY_VALUES}
        name="start_by"
        onChange={() => {
          onSubmit;
          trackEvent(
            EventCategories.POST_JOB_MODAL,
            `Press Answer - When do you want the work to start?`,
            category
          );
        }}
      />
      <Button
        disabled={!!invalid}
        type={'submit'}
        m={0.5}
        block
        style={!invalid ? buttonAlignment : disabledButton}
        data-ga-interactive={false}
        data-ga-category={EventCategories.POST_JOB_MODAL}
        data-ga-action={EventActions.PRESS_NEXT_STARTBY_SCREEN}
        data-ga-label={category}
      >
        Next
      </Button>
    </Card>
  </Form>
);

StartByStep.propTypes = {
  invalid: PropTypes.bool,
  onSubmit: PropTypes.func,
  back: PropTypes.func,
  progress: PropTypes.string,
  category: PropTypes.string
};

const ConnectedStep = reduxForm({
  form: 'GQWIZARD',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(StartByStep);

export default connect()(ConnectedStep);
